var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowspec(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 86 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flowspec_svg__clip0_6_50)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M25.161 34.075L59.776 0H25.932L8.355 17.527 0 9.303v33.025h33.549l-8.388-8.253zm27.29-22.408l8.384 8.258L26.224 54h33.844l17.577-17.528L86 44.697v-33.03H52.45z",
    fill: "url(#flowspec_svg__paint0_linear_6_50)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "flowspec_svg__paint0_linear_6_50",
    x1: 43,
    y1: 0,
    x2: 43,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CB765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6F89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flowspec_svg__clip0_6_50"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h86v54H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODYiIGhlaWdodD0iNTQiIHZpZXdCb3g9IjAgMCA4NiA1NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzZfNTApIj4KPHBhdGggb3BhY2l0eT0iMC45IiBkPSJNMjUuMTYxMyAzNC4wNzUyTDU5Ljc3NjUgMEgyNS45MzE4TDguMzU1MTEgMTcuNTI3NUwwIDkuMzAyNzRWNDIuMzI4NUgzMy41NDlMMjUuMTYxMyAzNC4wNzUyWk01Mi40NTA0IDExLjY2NzNMNjAuODM1IDE5LjkyNDhMMjYuMjIzNSA1NEg2MC4wNjgyTDc3LjY0NDkgMzYuNDcyNUw4NiA0NC42OTczVjExLjY2NzhMNTIuNDUwNCAxMS42NjczWiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzZfNTApIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl82XzUwIiB4MT0iNDMiIHkxPSIwIiB4Mj0iNDMiIHkyPSI1NCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNUNCNzY1Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzFCNkY4OSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzZfNTAiPgo8cmVjdCB3aWR0aD0iODYiIGhlaWdodD0iNTQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgFlowspec as ReactComponent };